import ProctorCameraPreview from "./ProctorCameraPreview";
import { useViolation } from "./ViolationContext";

export default function ProctorPanel() {
  const { violations } = useViolation();

  return (
    <div className="w-72 bg-black text-white flex flex-col">

      {/* Camera Preview */}
      <div className="p-4 border-b border-white/10">
        <ProctorCameraPreview />
      </div>

      {/* Status */}
      <div className="p-4 text-xs space-y-2">
        <p className="text-green-400 font-semibold">
          ● Camera monitoring active
        </p>
        <p>🔒 Fullscreen enforced</p>
        <p>🚫 Tab switch blocked</p>
        <p>📝 Activity logged</p>

        <div className="text-red-400 font-semibold">
          Violations: {violations} / 3
        </div>
      </div>
    </div>
  );
}
